import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { isKioskMode } from 'checkout/selectors/ui';
import NameOnTicket from './NameOnTicket.js';

class NameOnTicketList extends Component {
    render() {
        if(this.props.isKiosk){
            return(
                <div className="kiosk__checkout__questions">
                    {this.renderItems()}
                </div>
            )
        }
        return (
            <div className="event-questions form-card">
                <div className="event-questions__header form-card__header">
                    <h4 className="event-questions__event-name" dangerouslySetInnerHTML={{__html: this.props.eventName}}></h4>
                </div>
                <div className="event-questions__body form-card__content">
                    <div className="question input">
                        {this.renderItems()}
                    </div>
                </div>
            </div>
        )
    }

    groupArrayOfObjectsByProperty = (arrayOfObjects, property) => {
        const group = {};
        arrayOfObjects.forEach(object => {
            if (!!object[property]) {
                if (!group[object[property]]) {
                    group[object[property]] = [];
                }
                group[object[property]].push(object);
            }
        });
        return group;
    }

    /**
     * Group tickets and bundles by price level/bundle ID so that they can be displayed in a reasonable order
     */
    groupItems = () => {
        const grouped = {};
        // regular tickets by price level ID
        grouped.tickets = this.groupArrayOfObjectsByProperty(this.props.tickets, 'price_level_id');
        // regular bundle sales by bundle ID
        grouped.bundles = this.groupArrayOfObjectsByProperty(
            this.props.bundles.filter(b => !b.multiple_ticket_holders),
            'bundle_id'
        );
        // multiple ticket holder bundle sales by bundle ID by price level ID
        grouped.multipleTicketHolderBundles = this.groupArrayOfObjectsByProperty(
            this.props.bundles.filter(b => !!b.multiple_ticket_holders),
            'bundle_id'
        );
        // tickets on bundle sales by price level ID
        grouped.bundleTickets = {};
        const bundleTicketsByBundleSaleId = this.groupArrayOfObjectsByProperty(
            this.props.bundleTickets,
            'bundleSaleId'
        );
        Object.keys(bundleTicketsByBundleSaleId).forEach(bundleSaleId => {
            grouped.bundleTickets[bundleSaleId] = this.groupArrayOfObjectsByProperty(
                bundleTicketsByBundleSaleId[bundleSaleId],
                'price_level_id'
            );
        });
        return grouped;
    }

    getNameOnTicket = id => {
        return this.props.ticketNames?.[id] ?? '';
    }

    getNameOnBundleSale = id => {
        return this.props.bundleNames?.[id] ?? '';
    }

    renderItems = () => {
        const grouped = this.groupItems();
        return (
            <Fragment>
                {Object.values(grouped.bundles).map(bundleArray => {
                    return bundleArray.map((bundle, index) => {
                        return this.renderItem(
                            `bundlename_${bundle.bundle_id}_${index}`,
                            bundle.name,
                            bundleArray.length > 1 ? index + 1 : null,
                            this.getNameOnBundleSale(bundle.id),
                            bundle.id,
                            true
                        );
                    })
                })}
                {Object.values(grouped.multipleTicketHolderBundles).map(bundleArray => {
                    return bundleArray.map((bundle, index) => {
                        const bundleTicketsGrouped = grouped.bundleTickets[bundle.id];
                        if (!bundleTicketsGrouped) {
                            return null;
                        }
                        return Object.values(bundleTicketsGrouped).map((bundleTickets, bundleTicketsIndex) => {
                            return bundleTickets.map((bundleTicket, bundleTicketIndex) => {
                                const bundleNumberString = bundleArray.length > 1 ? ` #${index + 1}` : ''
                                return this.renderItem(
                                    `bundleticketname_${bundle.id}_${bundleTicketsIndex}_${bundleTicketIndex}`,
                                    `${bundle.name}${bundleNumberString}, ${bundleTicket.price_level_name}`,
                                    bundleTickets.length > 1 ? bundleTicketIndex + 1 : null,
                                    this.getNameOnTicket(bundleTicket.id),
                                    bundleTicket.id
                                );
                            });
                        });
                    });
                })}
                {Object.values(grouped.tickets).map(ticketArray => {
                    return ticketArray.map((ticket, index) => {
                        return this.renderItem(
                            `ticketname_${ticket.price_level_id}_${index}`,
                            ticket.price_level_name,
                            ticketArray.length > 1 ? index + 1 : null,
                            this.getNameOnTicket(ticket.id),
                            ticket.id
                        );
                    })
                })}
            </Fragment>
        );
    }

    renderItem = (index, itemName, itemNum, value, itemId, isBundle = false) => {
        const label = itemNum ? `${itemName} #${itemNum}` : itemName;

        const onChange = isBundle
        ? val => {this.props.onSetBundleName(itemId, val)}
        : val => {this.props.onSetTicketName(itemId, val)}

        const onFocus = e => {
            const dispatchCallback = val => {
                return () => {
                    onChange(val);
                }
            }
            this.props.onInitKeyboard(e.target, 'Full Name', dispatchCallback);
        }

        return <div className="ticket-question" key={index}>
            <div className="ticket-questions__header">
                <h5 className="ticket-questions__ticket-name">
                    {label}
                </h5>
            </div>
            <div className="ticket-questions__body">
                <div className="question input">
                    <NameOnTicket
                        value={value}
                        onChange={e => {onChange(e.target.value)}}
                        isBundle={isBundle}
                        onFocus={onFocus}
                        id={itemId}
                    />
                </div>
            </div>
        </div>
    }

}

NameOnTicketList.propTypes = {
    isKiosk: PropTypes.bool,
    eventName: PropTypes.string,
    tickets: PropTypes.array,
    bundleTickets: PropTypes.array,
    bundles: PropTypes.array,
    onSetTicketName: PropTypes.func.isRequired,
    onSetBundleName: PropTypes.func.isRequired,
    ticketNames: PropTypes.object.isRequired,
    bundleNames: PropTypes.object.isRequired,
    onInitKeyboard: PropTypes.func.isRequired,
}

export default NameOnTicketList;
